import { render, staticRenderFns } from "./TicketBlockSellers.vue?vue&type=template&id=2ffc2c0a"
import script from "./TicketBlockSellers.vue?vue&type=script&lang=js"
export * from "./TicketBlockSellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports